import { isObject, isString, isEmpty, isArray } from "iotera-base/object";
import { safeDeepGetWithType } from "iotera-base/json";
import {
    WEBSERVICE_FETCH, isChart, isCommandCard, isInputCommandCard,
    hasNoBackground, isCustomCommand, isDownloadable, BUTTON_TAGS_CARD
} from "../lib/components/Preference";

export function parseNav(domainIsTenant, navId, navDashboard, customCallback, dashConf) {

    const resultConfig = {};
    const backgroundConfig = {};
    const monitoringKeys = {};
    const singleConfig = {};
    const initRequest = {};
    resultConfig['background_config'] = backgroundConfig;
    resultConfig['is_monitoring'] = monitoringKeys;
    resultConfig['single_config'] = singleConfig;
    resultConfig['refresh_data'] = initRequest;

    if (!isString(navId) || !isObject(navDashboard)) {
        return resultConfig;
    }

    let size = Object.keys(navDashboard).length;

    let defaultPeriod = size > 5 ? size * 1000 : 0;

    let dashboardPeriod = safeDeepGetWithType(dashConf, ["refresh"], defaultPeriod);
    if (dashboardPeriod === 0) {
        dashboardPeriod = defaultPeriod
    }

    let wcallback = isEmpty(customCallback) ? {} : customCallback
    for (let id in navDashboard) {
        const config = navDashboard[id];
        const cat = safeDeepGetWithType(config, ["cat"], '');
        const dependedToId = safeDeepGetWithType(config, ["model", "affected_by"], '');
        let period = safeDeepGetWithType(config, ["config", "refresh"], dashboardPeriod);

        if (period === 0) {
            period = dashboardPeriod
        }

        initRequest[id] = {
            wparam: {
                ...domainIsTenant,
                type: WEBSERVICE_FETCH,
                path: "/fetch/web/g/" + navId + "/" + id
            }

        }

        if (isDownloadable(cat)) {
            const downloadId = buildDownloadId(id);
            singleConfig[downloadId] = {
                wparam: {
                    ...domainIsTenant,
                    type: WEBSERVICE_FETCH,
                    responseType: 'text',
                    path: "/fetch/web/file/csv/card/" + navId + '/' + id,
                    timeout: 120000
                },
                wcallback,
                wenv: { params: downloadId }
            }
        }

        if (dependedToId !== '') {
            // For todo after select something
            singleConfig[id] = {
                wparam: {
                    ...domainIsTenant,
                    type: WEBSERVICE_FETCH,
                    path: "/fetch/web/g/" + navId + "/" + id
                },
                wenv: { params: id }
            }

            // For depended background
            backgroundConfig[id] = {
                wparam: {
                    ...domainIsTenant,
                    type: WEBSERVICE_FETCH,
                    path: "/fetch/web/g/" + navId + "/" + id
                },
                wenv: { params: id }
            }

            if (period > 0) {
                backgroundConfig[id]['wperiod'] = period;
            }

        } else {

            if (isChart(cat)) {
                monitoringKeys[id] = {}

                // For todo after select dropdown
                singleConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                backgroundConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                if (period > 0) {
                    backgroundConfig[id].wperiod = period;
                }

            } else if (isInputCommandCard(cat)) {

                // For todo after select dropdown
                singleConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                // For todo after command
                const commandId = buildCommandId(id);
                singleConfig[commandId] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        method: "POST",
                        path: "/fetch/web/p/" + navId + "/" + id,
                        timeout: 60000
                    },
                    wcallback,
                    wenv: { body: commandId }
                }

                const configValue = safeDeepGetWithType(config, ["model", "config"]);
                if (!isCustomCommand(cat)) {
                    if (configValue !== "config" && configValue !== "input") {
                        continue;
                    }
                }

                // For background
                backgroundConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                if (period > 0) {
                    backgroundConfig[id]['wperiod'] = period;
                }

            } else if (cat === BUTTON_TAGS_CARD) {

                // For todo after select dropdown
                singleConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                // For command
                const commandId = buildCommandId(id);
                singleConfig[commandId] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        method: "POST",
                        path: "/fetch/web/p/" + navId + "/" + id,
                        timeout: 60000
                    },
                    wenv: { body: commandId }
                }

                // For background
                backgroundConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                if (period > 0) {
                    backgroundConfig[id]['wperiod'] = period;
                }

            } else if (isCommandCard(cat)) {

                // For todo after select dropdown
                singleConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    },
                    wenv: { params: id }
                }

                // For command
                const commandId = buildCommandId(id);
                singleConfig[commandId] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        method: "POST",
                        path: "/fetch/web/p/" + navId + "/" + id,
                        timeout: 60000
                    },
                    wenv: { body: commandId }
                }

            } else if (hasNoBackground(cat)) {
                continue;
            } else {

                // For background
                backgroundConfig[id] = {
                    wparam: {
                        ...domainIsTenant,
                        type: WEBSERVICE_FETCH,
                        path: "/fetch/web/g/" + navId + "/" + id
                    }
                }

                if (period > 0) {
                    backgroundConfig[id]['wperiod'] = period;
                }
            }

        }

    }

    return resultConfig;
}

export function parseNavConf(domainIsTenant, navId, navDashboard, listDash) {

    const resultConfig = {};
    const initRequest = {};
    resultConfig['refresh_data'] = initRequest;

    if (!isString(navId) || !isObject(navDashboard)) {
        return resultConfig;
    }

    // let wcallback = isEmpty(customCallback) ? {} : customCallback

    if (!isArray(listDash)) {
        listDash = [];
    }

    for (let id in navDashboard) {
        initRequest[id] = {
            wparam: {
                ...domainIsTenant,
                type: WEBSERVICE_FETCH,
                path: "/fetch/web/g/" + navId + "/" + id
            }
        }

        listDash.push(id)

    }

    return resultConfig;
}

export function buildCommandId(id) {
    return `command_${id}`;
}

export function buildDownloadId(id) {
    return `download_${id}`;
}

export function buildDependedToId(id) {
    return `depended_to_${id}`;
}
